import React, { Component } from 'react';
import bonusArrow from "../../img/bonus_arrow.svg"
import star from "../../img/star-new.svg"
import ReactDOM from "react-dom";

export default class BonusProgram extends Component {
    constructor(props) {
        super(props);

        this.state = {
            bonus: false,
        };
    }

    loadBonusProgram() {
        const th = this;
        axios.post(routes.bonusProgram, {})
            .then(function (response) {
                th.setState({bonus: response.data})
            })
            .catch(function (error) {
                console.error('Error loading bonusProgram' + error);
            });
    }

    componentDidMount() {
        this.loadBonusProgram();
    }

    render() {
        const renderHTML = (escapedHTML: string) => React.createElement("div", { dangerouslySetInnerHTML: { __html: escapedHTML } });

        return (<div className="row pt-40 fullPos mx-0">
            <div className="col-12 gradBox p-20">
                <div className="d-flex flex-row justify-content-between ">
                    <div className="d-flex flex-row align-items-center">

                        <img src={star} width={25} height={24} className="bonus-star-program"/>
                        <span className="align-middle bonusTextTitle">Star Club</span>
                    </div>
                    <div className="d-inline-block pt-lg-0 pt-1" >
                        <a href={this.state.bonus.link}>
                        <span className="bonusText mr-1" style={{textDecoration: 'underline'}}>{translations.participate}</span>
                    <img src={bonusArrow} />
                </a>
            </div>
        </div>
        <hr style={{ borderTop: '1px solid rgba(255,255,255,0.50)'}} />
        <div className="w-100 bonusText" style={{fontSize: 16}}>{renderHTML(this.state.bonus.text)}</div>
    </div>
            <div className="blur-shadow"></div>
    </div>);
    }
}

if (document.getElementById('bonusProgramBanner')) {
    const el = document.getElementById('bonusProgramBanner');

    ReactDOM.render(<BonusProgram/>, el);
}



// WEBPACK FOOTER //
// ./resources/assets/react/components/BonusProgram.js